/**
 * @generated SignedSource<<de5071e4a1d7167da2b5f5aa4d7bfc63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizThemesNavigationTheme_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "58767c999e3c83a29e5ec6dd20a9de18";

module.exports = node;
